// workspace.resolver.ts
import { ResolveFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { EMPTY, forkJoin, of } from 'rxjs';
import { finalize, switchMap } from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';
import { LookUpService } from '../app/services/lookup-service/lookup.service';
import { LoginService } from '../app/services/login-service/login.service';
import { allowSystemPageNavigation } from '../guard/navigation-flag.guard';

export const workspaceResolver: ResolveFn<unknown> = () => {
  const lookUpService = inject(LookUpService);
  const loginService = inject(LoginService);
  const msalService = inject(MsalService);
  const router = inject(Router);
  const account =
    msalService.instance.getActiveAccount() ?? msalService.instance.getAllAccounts()[0];

  if (!account?.username) {
    return router.createUrlTree(['/']);
  }

  loginService.workspaceLoading.set(true);

  return loginService.checkActive(account.username).pipe(
    switchMap((response) => {
      if (!response) {
        return EMPTY;
      }

      if (response.status !== 'SUCCESS' || !response.data) {
        allowSystemPageNavigation('/unauthorized');
        return of(router.parseUrl('/unauthorized'));
      }

      loginService.setUsername(response.data.loginId);
      return forkJoin({
        programs: lookUpService.loadPrograms(),
        configPaths: loginService.validateConfigPaths(),
        initialLookups: lookUpService.loadInitialWorkspaceLookups(),
      });
    }),
    finalize(() => loginService.workspaceLoading.set(false)),
  );
};